import React, { useEffect, useRef, useState } from 'react';

/**
 * Reveal — révèle son contenu au scroll (fondu + translation).
 * Respecte prefers-reduced-motion via le CSS (.reveal).
 *
 * props:
 *  - as: élément à rendre (default 'div')
 *  - delay: délai d'apparition en ms (effet cascade)
 *  - className: classes additionnelles
 *  - once: ne joue qu'une fois (default true)
 */
const Reveal = ({ as: Tag = 'div', delay = 0, className = '', children, once = true, ...rest }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          if (once) observer.unobserve(entry.target);
        } else if (!once) {
          setVisible(false);
        }
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [once]);

  return (
    <Tag
      ref={ref}
      className={`reveal ${visible ? 'is-visible' : ''} ${className}`}
      style={{ '--reveal-delay': `${delay}ms` }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
